import styled from '@emotion/styled';

export const ItemListTileContainer = styled.div`
    margin: 0;
    height: 11rem;
    min-width: 45rem;
    display: grid;
    grid-template-columns: 20rem 1fr;

    & > .item-thumbnail {
        height: 11rem;
        border: 2px solid var(--background);
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #FFFFFF;

        & > * {
            object-fit: cover;
            max-width: 100%;
            max-height: 100%;
        }
    }

    :hover > .item-thumbnail {
        border-color: var(--plain__enabled__fill__hovered);
    }

    & .item-details-bar {
        align-content: start;
        display: grid;
        grid-template-columns: 3fr 2fr 18rem;
    }

    & .item-details-rows {
        word-break: break-all;
        line-height: 1rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
    }

    & .item-details-label-column {
        height: 3rem;
        width: 48px;
        padding-top: 0.5rem;
        padding-left: 8px;
        padding-right: 8px;
        margin-right: 8px;
    }
`;

export const ContextContainer = styled.div`
    display: grid;
    grid-template-rows: 1fr 1fr 3fr;
    height: inherit;
    padding: 1rem;
`;

export const DetailsBar = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    align-items: left;
`;

export const DetailsBarSectionLeft = styled.div`
    text-align: left;
    padding-top: 0;
`;

export const DetailsBarSectionCenter = styled.div`
    text-align: left;
    height: 3rem;
    overflow: hidden;
    display: -webkit-box;
    width: 100%;
`;

export const DetailsBarSectionRight = styled.div`
    text-align: left;
    height: 3rem;
    overflow: hidden;
    display: -webkit-box;
    width: 100%;

    > .itemButtons > .a-icon {
        font-size: 1.2rem;
    }
`;

export const LabelImages = styled.img`
    justify-content: center;
    text-align: center;
    align-self: center;
    max-height: 3rem;
    max-width: 48px;
`;

export const ItemTitleWrapper = styled.div`
    height: 2.4rem;
    overflow: hidden;

    > .item-title {
        > div {
            display: inline-flex;

            > div {
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }

            > i {
                align-self: flex-end;
                font-size: 1.5rem;
                line-height: 1.4;
            }
        }
    }

    & .item-chevron {
        margin-left: 0.5rem;
    }
`;

export const BottomDetailsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;

export const DescriptionSection = styled.div`
    height: max-content;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    word-break: break-all;
`;

export const DownloadButtonWrapper = styled.div`
    margin-left: 1rem;
    text-align: right;
    align-self: end;

    > button {
        grid-row: 2;
    }

    > button > i {
        font-size: 1.2rem;
        padding-right: 12px;
    }
`;
